import { useState } from "react";
import TriangleDownIcon from "../../icons/triangle/triangle-down-icon";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { setSelectedCurrency } from "../../../store/actions";

type CurrencySelectorProps = {
  isLoading: boolean;
};

function CurrencySelector({ isLoading }: CurrencySelectorProps) {
  const dispatch = useAppDispatch();
  const { selectedCurrency, currencyList } = useAppSelector((state) => state);

  const [isOpen, setIsOpen] = useState(false);
  const handleSelect = (currency: string) => {
    dispatch(setSelectedCurrency(currency));
    setIsOpen(false);
  };

  return (
    <div
      style={{ cursor: isLoading ? "default" : "pointer" }}
      className="connect-step-currency-selector__field"
      onClick={isLoading ? () => {} : () => setIsOpen(!isOpen)}
    >
      <span className="connect-step-currency-selector__selected">
        {isLoading && !currencyList ? "" : selectedCurrency?.toUpperCase()}
      </span>
      <span className="connect-step-currency-selector__currency-icon">
        <TriangleDownIcon />
      </span>

      {isOpen && (
        <ul className="connect-step-currency-selector__dropdown">
          {currencyList?.map((currency) => (
            <li
              key={currency}
              className={`connect-step-currency-selector__option ${
                selectedCurrency === currency ? "selected" : ""
              }`}
              onClick={() => handleSelect(currency)}
            >
              {currency.toUpperCase()}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default CurrencySelector;
